import React from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';

import { Container, Audio, ErrorContainer } from './styles';

function AudioPlayer({ location: { search } }) {
  const { url } = qs.parse(search, { ignoreQueryPrefix: true });

  if (!url) {
    return (
      <ErrorContainer>
        <p>No audio URL provided.</p>
      </ErrorContainer>
    );
  }

  return (
    <Container>
      <Audio controls src={url} />
    </Container>
  );
}

AudioPlayer.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
};

export default AudioPlayer;
